import Vue from 'vue';
// Make common toast notifications.
export const getToastInstance = () => {
  return {
    makeToastSuccess: message => {
      const vm = new Vue();
      vm.$bvToast.toast(message, {
        title: `Thông báo`,
        variant: 'success',
        solid: true
      });
    },
    makeToastWarning: message => {
      const vm = new Vue();
      vm.$bvToast.toast(message, {
        title: `Thông báo`,
        variant: 'warning',
        solid: true
      });
    },
    makeToastFailure: message => {
      const vm = new Vue();
      vm.$bvToast.toast(message, {
        title: `Thông báo`,
        variant: 'danger',
        solid: true
      });
    },
  };
};
